import { useState } from 'react'
import styled from '@emotion/styled'
import Skeleton from '@mui/material/Skeleton'

const Spinner = styled('div')(({ theme }) => ({

  height: 220,
  position: 'relative',
  overflow: 'hidden',
  width: '100%',
  '& img': {
    width: 40,
    height: 40,
    position: 'absolute',
    top: '50%',
    marginTop: '-20px',
    left: '50%',
    marginLeft: '-20px'
  }
}))

// eslint-disable-next-line react/prop-types
const ImageSpinner = ({ url, className }) => {
  const [loading, setLoading] = useState(true)
  const imageLoaded = () => {
    setLoading(false)
  }
  return (
    <>

      {loading && <Spinner>
        <Skeleton animation="wave" variant="rectangular" width="100%" height={220} />
      </Spinner>}

      <img
        style={{ display: loading ? 'none' : 'block' }}
        className={className}
        src={url}
        onLoad={imageLoaded}/>

    </>
  )
}

export default ImageSpinner
